import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			redirect: '/projects'
		},
		{
			path: '/projects',
			name: 'Projects',
			component: () => import(/* webpackChunkName: "projects" */ './views/Projects.vue'),
			meta: {
				title: 'Projects'
			}
		},
		{
			path: '/projects/:projectName',
			name: 'SingleProject',
			component: () => import(/* webpackChunkName: "projects" */ './views/Project.vue'),
			meta: {
				title: route => route.params.projectName
			}
		},
		{
			path: '/about',
			name: 'About',
			component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
			meta: {
				title: 'About'
			}
		},
		{
			path: '/farewell-rl-friends',
			name: 'Farewell',
			component: () => import(/* webpackChunkName: "farewell" */ './views/Farewell.vue'),
			meta: {
				title: 'Farewell RL friends'
			}
		},
		{
			path: '/farewell-rl-friends/:id',
			name: 'Friend',
			component: () => import(/* webpackChunkName: "farewell" */ './views/Friend.vue'),
			meta: {
				title: 'Farewell RL friends'
			}
		}
	]
})

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = 'Blake Lipson | ' + to.meta.title;
	}
	return next();
})

export default router